<template>
<div>
  <div class="cart-entry"
       :class="{'cart-entry-selected': checked, 'invalid': item.is_invalid}"
       :style="item.unionsInfo.length>0?'border-bottom: none;':'margin-bottom: 12px;'">
    <div class="table-cell select-button col-1">
      <div v-if="!item.is_invalid"
           class="zhixin-checkbox-wrapper">
        <input type="checkbox"
               :id="'checkbox-' + item.goods_id"
               name="goods_id"
               :value="item.goods_id"
               :checked="checked"
               @click="selectChange" />
        <el-popover v-if="item.tips"
                    placement="top"
                    title=""
                    width="200"
                    trigger="hover"
                    :content="item.tips">
          <label :for="'checkbox-' + item.goods_id"
                 slot="reference"></label>
        </el-popover>
        <label v-else
               :for="'checkbox-' + item.goods_id"></label>
        <div class="check"></div>
        <div class="fa-zhixin fa-check"></div>
      </div>
      <span v-else
            class="hidden-xs"
            style="width: 46px;z-index: 2;position: relative;font-size: 12px;">已失效</span>
    </div>
    <div class="table-cell hidden-ipad col-2">
      <img :src="item.cover"
           width="170"
           height="96"
           :alt="item.subject">
    </div>
    <div class="table-cell col-3"
         style="padding-left: 40px;">
      <div class="strong hidden-xs">
        <a class="text-ellipse"
           :href="'/class-detail/' + item.classId + (item.goods_type === 2 ? '/live' : '/offline')">
          {{ item.subject }}</a>
      </div>
      <div class="strong visible-xs">
        <a :href="'/class-detail/' + item.classId + (item.goods_type === 2 ? '/live' : '/offline')"
           style="font-weight:500">{{ item.subject }}</a>
        <div v-if="!item.is_invalid"
             class="table-cell col-6 visible-xs"
             style="float:right;width: fit-content;margin-bottom: -2px;">
          <span @click="deleteItem"
                class="delete"
                style="vertical-align: middle;"><i class="fa-zhixin fa-delete-btn"></i> 删除</span>
        </div>
      </div>
      <div class="visible-xs">
        <span :class="{duration: item.duration&&item.duration.time}">
          {{ item.duration&& item.duration.date }}{{ item.duration&&item.duration.time }}
        </span>
        <span class="chapters">| 共{{ item.chapters.length }}节</span>
      </div>
      <div class="teacher">授课老师：{{ item.teachers }}</div>
      <div v-if="item.materials.length"
           class="ziliao entry-ziliao">
        <span><i class="fa-v2 fa-zeng"></i>&nbsp;&nbsp;教材&福利*{{ item.materialsCount }}</span>
      </div>
    </div>
    <div class="table-cell col-4 hidden-xs"
         style="padding-left: 40px;">
      <div>{{ item.duration&& item.duration.date }}</div>
      <div>
        <span :class="{duration: item.duration && item.duration.time}">{{ item.duration&&item.duration.time }}</span>
        <span class="chapters">| 共{{ item.chapters.length }}节</span>
      </div>
    </div>
    <!-- price -->
    <div class="table-cell col-5 cart-price-box"
         style="padding-left: 40px;">
      <slot v-if="item.group_set">
        <div class="visible-xs">
          <span class="origin-price delete-price">￥{{ Number((item.price/100).toFixed(2)) }}</span>
          <span class="group-price">￥{{ Number((item.groupsPrice/100).toFixed(2)) }}</span>
          <span class="badge">团购价</span>
        </div>
        <div class="hidden-xs">
          <div class="origin-price delete-price">￥{{ Number((item.price/100).toFixed(2)) }}</div>
          <div class="group-price">￥{{ Number((item.groupsPrice/100).toFixed(2)) }}</div>
          <div class="badge">团购价</div>
        </div>
      </slot>
      <slot v-else>
        <span v-if="item.virtual_price&&!item.left_sub_price"
              class="delete-price origin-price">
          ￥{{ Number((item.virtual_price/100).toFixed(2)) }}
        </span>
        <div class="text-center">
          <span v-if="item.left_sub_price !== item.price"
                class="origin-price delete-price">
            ￥ {{ Number((item.price/100).toFixed(2)) }}
          </span>
          <span class="active-price">￥{{ Number((item.needPrice/100).toFixed(2)) }}</span>
          <slot v-if="item.left_sub_count && item.left_sub_count !== item.chapters.length">
            <br><span class="badge badge-warning">剩余{{ item.left_sub_count }}章节</span>
          </slot>
        </div>
      </slot>
      <div :style="isMobileStyle?'':'text-align: center;'">
        <span v-if="item.material_goods_id>0"
              style="padding:2px;
              border-radius: 2px;
          font-size: 12px;
          background: rgba(198, 205, 218, 0.3);
          color: rgba(51, 51, 51, 0.5);">含{{(item.material_goods_price)}}元教材费</span>
      </div>
    </div>
    <div v-if="!item.is_invalid"
         class="table-cell col-6 hidden-xs"
         style="width:119px;text-align: right;padding-right: 5px;">
      <span @click="deleteItem"
            class="delete"><i class="fa-zhixin fa-delete-btn"></i> 删除</span>
    </div>
  </div>
  <div class="lianbao-list" :class="{'lianbao-list-checked': checked}" v-if="item.unionsInfo.length>0" :style="isMobileStyle?'padding: 0px 0px 15px 0px;':''">
    <div class="lianbao-info" :style="isMobileStyle?'padding: 15px 0px 0px 12px;':''">
    推荐联报：<span @click="toUnion(uitem.union_id, item.classId, item.goods_id)" v-for="(uitem, index) in item.unionsInfo" :key="index">{{unionType[uitem.union_template.union_type || 99]}}
      <i class="fa fa-chevron-right"
style="transform: translateY(-1px) translateX(-2px);"></i>
    </span>
    </div>
  </div>
</div>
</template>

<script>
import $ from 'jquery'
import { UnionType } from '@/utils/constants'
import api from '@/api'

export default {
  props: {
    index: Number,
    item: Object,
    checked: Boolean,
    isLianBao: Boolean
  },
  data () {
    return {
      unionType: UnionType
    }
  },
  computed: {
    isMobileStyle () {
      return document.body.clientWidth < 768
    }
  },
  methods: {
    toUnion (unid, classid, goodsid) {
      const params = {
        union_id: unid,
        goods_id: goodsid
      }
      api.canGoodsBuyUnion(params).then(res => {
        if (res.data.code === 1) {
          this.$router.push({
            name: 'Union',
            params: { unionId: unid, classId: classid }
          })
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    selectChange (e) {
      if (this.item.tips) {
        e.preventDefault()
        this.$message.warning(this.item.tips)
        return false
      }
      const checked = $(e.currentTarget).prop('checked')
      this.$parent.selectChange([this.item], checked, this.isLianBao, this.index)
    },
    deleteItem () {
      this.$parent.deleteItem([this.item.goods_id])
    }
  }
}
</script>
<style lang="scss">
  .lianbao-list{
    margin-bottom: 13px;
    border: 1px solid rgba(51, 51, 51, 0.1);
    border-top: none;
    padding: 0px 0px 15px 82px;
    .lianbao-info{
      border-top: 1px dashed rgba(51, 51, 51, 0.1);
      padding-top: 15px;
      font-size: 14px;
      font-weight: 500;
      color: rgba(51, 51, 51, 0.8);
      span{
      font-size: 14px;
      font-weight: 400;
      color: #FFA50D;
      margin-right: 10px;
      cursor: pointer;
      }
    }
  }
  .lianbao-list-checked{
    background: rgba(0, 199, 191, 0.04);
  }
</style>
